// Each entry is one wedding cake style. Cake ids are prefixed with "wedding_" so they can be
// told apart from regular cakes on the order page. An optional `size` overrides the default
// "3-layer serves 50 people" description.
const WEDDING_CAKES = Object.freeze([
  {
    id: "wedding_gold_leaf_petals",
    name: "Gold leaf petals wedding cake",
    image: "/assets/wedding-cakes/white-gold-leaf-petals-wedding-cake.jpg",
    price: "$680",
  },
  {
    id: "wedding_eucalyptus_white_roses",
    name: "Eucalyptus & white roses wedding cake",
    image: "/assets/wedding-cakes/eucalyptus-white-roses-wedding-cake.jpg",
    price: "$730",
  },
  {
    id: "wedding_monogram_white_roses",
    name: "Monogram white roses wedding cake",
    image: "/assets/wedding-cakes/monogram-white-roses-wedding-cake.jpg",
    price: "$700",
  },
  {
    id: "wedding_pastel_sugar_flowers",
    name: "Pastel sugar flowers wedding cake",
    image: "/assets/wedding-cakes/pastel-sugar-flowers-wedding-cake.jpg",
    price: "$650",
  },
  {
    id: "wedding_pleated_roses_celebration",
    name: "Pleated roses celebration cake",
    image: "/assets/wedding-cakes/pleated-roses-celebration-cake.jpg",
    price: "$220",
    size: "Serves 20 people",
  },
  {
    id: "wedding_lisianthus_rectangular",
    name: "Lisianthus rectangular wedding cake",
    image: "/assets/wedding-cakes/lisianthus-rectangular-wedding-cake.jpg",
    price: "$470",
    size: "Serves 60 people",
  },
  {
    id: "wedding_raspberry_blueberry",
    name: "Raspberry & blueberry wedding cake",
    image: "/assets/wedding-cakes/raspberry-blueberry-wedding-cake.jpg",
    price: "$650",
    size: "Serves 50 people",
  },
]);

const WEDDING_CAKE_IDS = WEDDING_CAKES.map((cake) => cake.id);

const isWeddingCake = (cakeId) => WEDDING_CAKE_IDS.includes(cakeId) || cakeId === "wedding";

export { WEDDING_CAKES, isWeddingCake };
